import { render } from "./MostPopularProductComponent.vue?vue&type=template&id=1c08875c"
import script from "./MostPopularProductComponent.vue?vue&type=script&lang=js"
export * from "./MostPopularProductComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/product/MostPopularProductComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c08875c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c08875c', __exports__)) {
    api.reload('1c08875c', __exports__)
  }
  
  module.hot.accept("./MostPopularProductComponent.vue?vue&type=template&id=1c08875c", () => {
    api.rerender('1c08875c', render)
  })

}


export default __exports__